import { ActivitiesBehavior, CartFeatures } from 'core/type/behaviors.types';
import { search as locationSearch } from 'core-framework/window/location';
import { AppFeaturesToggleEnum, BootstrapConfig } from 'core/type/BootstrapConfig.types';

export const isCartDebug = (): boolean => {
    return locationSearch().includes('cartDebug=yes');
};

export const getShoppingCartBehavior = (bootstrapConfig: BootstrapConfig): boolean => {
    const isShoppingCartEnabled = !!bootstrapConfig.behavior.common.shoppingCart;
    const isWebView = bootstrapConfig.isWebView;
    const webViewFeatureToggles = bootstrapConfig?.webViewFeatureToggles || [];

    return isCartDebug() || isWebView ? webViewFeatureToggles.includes(AppFeaturesToggleEnum.EnableActivitiesInCart) && isShoppingCartEnabled : isShoppingCartEnabled;
};

export const getCartFeaturesBehavior = (behavior: ActivitiesBehavior): CartFeatures => {
    return behavior.cartFeatures;
};

export const selectIsAddAnyItemsToCart = (behavior: ActivitiesBehavior): boolean => {
    return behavior.cartFeatures.addAnyItemToCart;
};

export const selectIsRebrandCartToSaved = (behavior: ActivitiesBehavior, isWebView: boolean): boolean => {
    return isWebView ? behavior.cartFeatures.rebrandCartToSavedWebview : behavior.cartFeatures.rebrandCartToSaved;
};
